// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ob_600Cg4","isSelected":"ob_5kYhsR"};